import React from "react";
import { Link } from "react-router-dom";
import { FaLinkedin, FaInstagram, FaFacebook, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Company Info */}
        <div className="footer-col company-info">
          <img
            src="/Assets/protek logo.png"
            alt="Protek Logo"
            className="footer-logo"
            loading="lazy"
          />
          <h3>Protek Consult</h3>
          <p className="footer-desc">
            We are a leading civil engineering and architecture firm based in
            Hyderabad, India.
          </p>
          <div className="footer-socials">
            <a
              href="https://www.linkedin.com/company/protek-consult/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.instagram.com/protekconsult_/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.facebook.com/share/15eBTjSZ7K/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebook />
            </a>
            <a
              href="https://x.com/srinivas_protek"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X (Twitter)"
            >
              <FaXTwitter />
            </a>
            <a
              href="https://www.youtube.com/@protekconsult214"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>
          </div>
        </div>

        {/* Projects */}
        <div className="footer-col">
          <h4>PROJECTS</h4>
          <ul>
            <li>Residential</li>
            <li>Commercial</li>
            <li>Layouts</li>
            <li>Industrial</li>
            <li>Interior</li>
            <li>Landscape</li>
          </ul>
        </div>

        {/* Useful Links */}
        <div className="footer-col">
          <h4>USEFUL LINKS</h4>
          <ul>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/gallery">Gallery</Link>
            </li>
            <li>
              <Link to="/blogs">Blogs</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col contact-col">
          <h4>CONTACT</h4>
          <div className="footer-contact-tabs">
            <span className="active">Hyderabad</span>
          </div>
          <div className="footer-contact-details">
            <div className="footer-contact-item">
              <span role="img" aria-label="address">
                📍
              </span>
              <span>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Door+401,+Pavani+Anasuya+Towers,+Tarnaka,+Hyderabad"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "inherit", textDecoration: "underline" }}
                >
                  Door 401, Pavani Anasuya Towers, Tarnaka, Hyderabad.
                </a>
              </span>
            </div>
            <div className="footer-contact-item">
              <span role="img" aria-label="phone">
                📞
              </span>
              <span>
                <a
                  href="tel:9030064343"
                  style={{ color: "inherit", textDecoration: "underline" }}
                >
                  90300 64343
                </a>{" "}
                /{" "}
                <a
                  href="tel:9959996069"
                  style={{ color: "inherit", textDecoration: "underline" }}
                >
                  99599 96069
                </a>
              </span>
            </div>
            <div className="footer-contact-item">
              <span role="img" aria-label="email">
                ✉️
              </span>
              <span>
                <a
                  href="mailto:info@protekconsult.com"
                  style={{ color: "inherit", textDecoration: "underline" }}
                >
                  info@protekconsult.com
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <span>Copyrights © Protek Consult {new Date().getFullYear()}. All rights reserved.</span>
        <span className="footer-credit">
          Website by{" "}
          <a href="https://vrnd.tech" target="_blank" rel="noopener noreferrer">
            VRND Business Solutions
          </a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
